// src/app/auth/auth-guard.service.ts

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { RequestOptions } from '@angular/http';

@Injectable()
export class UserService {
  private loggedIn: boolean;

  constructor(public http: HttpClient) {}

  register(profile) { return this.http.post('/accounts/', profile); }

  logout() {    
    return this.http.post('/accounts/logout', {});
  }

  recoverPassword(email) {
    return this.http.post('/accounts/recoverPassword', {username: email});
  }

  resetPassword(code, pass) {
    return this.http.post(
        '/accounts/resetPassword', {code: code, newPassword: pass});
  }

  getUserApps() { 
    return this.http.get('/accounts/user_apps');
  }

  removeUserApp(appId) {
    return this.http.delete('/accounts/user_apps/' + appId.id);
  }

  getUserProfile() { return this.http.get('/accounts/me'); }

  confirmAccount(c) {    
    return this.http.post('/accounts/confirm', {code: c});
  }

  updateUser(user) {
    return this.http.put('/accounts/', user);
  }  
}


// WEBPACK FOOTER //
// ./src/app/services/user.service.ts